export const RequestStatus = {
    Credit: 1,
    General: 2,
    Cancelation: 3,
};